/* global cco */
module.exports = function footerContent() {
  var year = new Date().getFullYear();
  return "&copy; ".concat(year, " ").concat(cco.copyrightHolder, ". All Rights Reserved. | <a href=\"").concat(cco.links.terms, "\">Terms and Conditions</a> and <a href=\"").concat(cco.links.privacy, "\">Privacy Policy</a>");
};